<nav [ngClass]="isMobileNav 
  ? 'fixed bottom-0 left-0 right-0 w-full bg-white text-gray-900 dark:bg-gray-800 dark:text-white ' 
  : ' bg-white text-gray-900 dark:bg-gray-800 dark:text-white'">

  <ul [ngClass]="isMobileNav ? 'flex justify-around' : ''">
    <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a routerLink="demographics" routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
        data-cy="page-caseDetails-link-tabOverview"
        [queryParamsHandling]="'preserve'" [ngClass]="isMobileNav 
           ? 'flex flex-col items-center text-xs px-2 py-2' 
           : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'">
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">person</span>
        <span class="hidden md:inline">Case Overview</span>
        <span class="md:hidden">Summary</span>
      </a>
    </li>
    <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a routerLink="appointments" routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
        data-cy="page-caseDetails-link-tabAppointments"
        [queryParamsHandling]="'preserve'" [ngClass]="isMobileNav 
           ? 'flex flex-col items-center text-xs px-2 py-2' 
           : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'">
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">event</span>
        Appointments
      </a>
    </li>
    <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a routerLink="documents" routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
        data-cy="page-caseDetails-link-tabDocuments"
        [queryParamsHandling]="'preserve'" [ngClass]="isMobileNav 
           ? 'flex flex-col items-center text-xs px-2 py-2' 
           : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'">
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">folder_open</span>
        Documents
      </a>
    </li>
    <!-- <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a routerLink="tasks" routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white" [queryParamsHandling]="'preserve'" [ngClass]="isMobileNav 
           ? 'flex flex-col items-center text-xs px-2 py-2' 
           : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'">
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">task</span>
        Tasks
      </a>
    </li> -->
    <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a routerLink="dictation" routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
        data-cy="page-caseDetails-link-tabDictations"
        [queryParamsHandling]="'preserve'" [ngClass]="isMobileNav 
           ? 'flex flex-col items-center text-xs px-2 py-2' 
           : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'">
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">mic</span>
        Dictations
      </a>
    </li>
    <!-- <li [ngClass]="isMobileNav ? '' : 'mb-2'">
      <a routerLink="notes" routerLinkActive="bg-sky-200 dark:bg-gray-700 dark:text-white"
        [queryParamsHandling]="'preserve'" [ngClass]="isMobileNav 
           ? 'flex flex-col items-center text-xs px-2 py-2' 
           : 'flex items-center p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700'">
        <span class="material-symbols-outlined" [ngClass]="isMobileNav ? '' : 'mr-2'">note_stack</span>
        Notes
      </a>
    </li> -->
  </ul>
</nav>